(function user_menu_dropdown() {
  $('body').on('click', '.user-dropdown-menu a', function (e) {
    //cogemos el menú
    const menu = $('.user-dropdown-menu');
    //cambiamos la etiqueta
    const label = e.currentTarget.innerText.split('\n')[0];
    menu.find('button span').text(label);
    //cerramos el dropdown
    const dropdown = menu.find('.uk-dropdown').get(0);
    UIkit.dropdown(dropdown).hide(0);
  });
})();
